import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import useMapStore from "@/store/mapStore";
import { useState, useEffect } from "react";

// Custom hook for formatting current date and time
export default function useCurrentDate() {
  const [currentDate, setCurrentDate] = useState(Date.now());
  const currentLang = useMapStore((state) => state.currentLang);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      setCurrentDate(now);
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  // Function to format the date in "Do MMM YY" format
  const formatDate = () => {
    return new Intl.DateTimeFormat(
      currentLang === "en" ? "en-GB" : currentLang,
      {
        day: "numeric",
        month: "short",
        year: "2-digit",
      },
    ).format(currentDate);
  };

  // Function to format the time in "6:43PM" format
  const formatTime = () => {
    let time = moment.tz(currentDate, moment.tz.guess()).format("hh:mm a");
    if (currentLang === "ar") {
      return time.replace("pm", "مساء").replace("am", "صباحا");
    }
    let hours = time.split(":")[0];
    hours = hours !== "00" ? hours : "12"; // the hour '0' should be '12'
    time = time.slice(2);
    time = hours + time;
    return time;
  };

  return {
    formatDate,
    formatTime,
  };
}
